import { render } from "./EmployeeSalaryDeduction.vue?vue&type=template&id=7e09cae1&scoped=true"
import script from "./EmployeeSalaryDeduction.vue?vue&type=script&lang=js"
export * from "./EmployeeSalaryDeduction.vue?vue&type=script&lang=js"

import "./EmployeeSalaryDeduction.vue?vue&type=style&index=0&id=7e09cae1&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e09cae1"]])

export default __exports__